var _mask, _g, _mask2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIcPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a612",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 9,
    width: 12,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.348 9.222c-3.02 0-5.598.476-5.598 2.38C1.75 13.507 4.313 14 7.348 14c3.019 0 5.598-.475 5.598-2.38 0-1.905-2.562-2.398-5.598-2.398z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a612)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b6926)",
    d: "M1.141 8.75h12.25V14H1.141z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "c626",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 9,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.348 7.409a3.691 3.691 0 0 0 3.704-3.705A3.691 3.691 0 0 0 7.348 0a3.692 3.692 0 0 0-3.704 3.704A3.692 3.692 0 0 0 7.348 7.41z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c626)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d362)",
    d: "M3.5 0h7.875v7.875H3.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6926",
    x1: 1.141,
    y1: 8.75,
    x2: 1.141,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d362",
    x1: 3.5,
    y1: 0,
    x2: 3.5,
    y2: 7.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcPerson);
export default __webpack_public_path__ + "static/media/icon-ic-person.9e312d5b.svg";
export { ForwardRef as ReactComponent };